// $(document).ready(function(){
//     $(".custom-navigation a").mouseover(function(){
//         $('.custom-navigation-dropdown').css({"display": "block", "overflow": "visible", "opacity": "1"});
//       console.log("All Ok");
//     });
//     $(".custom-navigation-dropdown").mouseleave(function(){
//         $(this).css({"display": "none", "overflow": "hidden", "opacity": "0"});
//     });
// });

// $(document).ready(function(){
//     $(".custom-navigation").mouseover(function(){
//       $(this).attr('data-x-menu--open', true);
//       $('.custom-navigation a').attr('aria-expanded', true);
//       $('transition-root').attr('data-transition', 'forwards');
//       $('transition-root').css('height', 'auto');
//     });
//     // $(".custom-navigation-dropdown").mouseleave(function(){
//     //     $(this).css({"display": "none", "overflow": "hidden", "opacity": "0"});
//     // });
// });

$(document).ready(function (){
  $("#modal-content-size").addClass("newactive");
  $(".modal--content-heading").click(function(){
    $(".newactive").removeClass("newactive");
    $(this).addClass("newactive");
  });
  $(".product-size-chart-btn").click(function () {
    $(this).parents(".product-size-chart--modal").toggleClass("active");
  });
  $(".modal--content-cross-btn svg").click(function () {
    $(this).parents(".modal--content").removeClass("active");
    $("transition-root.modal--mask").click();
  });
  $("#modal-content-measure").click(function () {
    // $(this).addClass("active");
    // $("#modal-content-size").removeClass("active");
    // $("#modal-content-size").css('text-decoration', 'none');
    //  $(this).css("text-decoration", "underline");
    $(".product-size-chart--modal").css("display", "block");
    $(".product_size_conversion_content").css("display", "none");
  });
  $("#modal-content-size").click(function () {
    // $(this).addClass("active");
    // $("#modal-content-measure").removeClass("active");
    //  $("#modal-content-measure").css('text-decoration', 'none');
    // $(this).css("text-decoration", "underline");
    $(".product-size-chart--modal").css("display", "none");
    $(".product_size_conversion_content").css("display", "block");
  });





  
  // $(".itg-float-div .product-buy-buttons--cta").click(function () {
  //   $(this).css({ color: "#fff", "background-color": "#000" });
  //   setTimeout(function() {
  //     alert('aa');
  //    $(this).css({ color: "#000", "background-color": "#fff" });
  //   }, 1000);
  // });





  //    $(".header--container li a").hover(function(){
  //    $(".x-menu--level-2--list ").trigger('click');
  // });

  // $(".header--container li a").on('dblclick', function(e) {
  //     alert("yes");
  // });


 $(".modal--window").find('.image--root').parents('.modal--content ').css("background", "transparent");



   // $(".filter--wrapper .filter--link").click(function () {
   //    // $(".navigation--container .navigation--button ").removeClass("active");
   //   $('.navigation--container').find('.navigation--button').trigger('click');
   // });



// var demo = $('.product-page--desktop-container').outerHeight();
//   console.log(demo);
  
//    $(window).scroll(function(){ 
//      var win = $(window).height();
//      console.log(win);
//    if( demo > win){
//     $('.product-page--desktop-container').parents('.product-page--root').removeClass("ast-root-height");
//  }else{
     
//      $('.product-page--desktop-container').parents('.product-page--root').addClass("ast-root-height");
//  }

// });
  
//     $(function() {
//     var header = $('.product-page--root');
//     $(window).scroll(function() {

//  var test = $('.template--product').outerHeight();  
//     var demo = $('.product-page--desktop-container').outerHeight();  

//     console.log(test);
//      console.log(demo);
      
//         var scroll = $(window).scrollTop();

//         if (test <= demo) {
//             header.addClass('dark');
          
//         } else {
//             header.removeClass('dark');
           
//         }
//     });
// // })


  var debounceTimer;

  
    $('.predictive-search--view-all').hide();
 $(document).on('input', '.cstm_search__input', function(e) {
    $('.predictive-search--view-all').hide();
       $(document).find('body').addClass("SearchLoaderHeader");
     // if( e.keyCode == 13 ){
       let searchVal = $(this).val();
  console.log('ITG0001');
            clearTimeout(debounceTimer);

   debounceTimer = setTimeout(function() {
                 console.log('ITG0002');

              if(searchVal.trim()) {
                 console.log('ITG0003');
                
                 var url2 = '&resources[type]=product'
                 // var url2 = '&resources[type]=product&resources[options][fields]=title'
                  
                 $.ajax({
                    url :  window.location.origin + '/search?q=' +searchVal + url2,
                    type: 'GET',
                    dataType: 'html', 
                    success: function(data) {
                       $('.result').html(' ');
                       $('.result').append( $(data).find('.search-results--root').html());

                      console.log('ITG0005  -  ' + $(data).find('.search_count').text());
                       $(document).find('.search_count').text($(data).find('.search_count').text());

                           $(document).find('body').removeClass("SearchLoaderHeader");
                      
                      
                      
                      $('.predictive-search--view-all a').attr('href',window.location.origin + '/search?q=' +searchVal + '*')
                      $('.predictive-search--view-all').show();
                      searchProductTotal = Number($(data).find('.search_count').text());
                      productsPerPage = Number($('.result .search-results--products').attr('data-products_per_page'));
                       if( searchProductTotal == 0 || searchProductTotal < productsPerPage ){
                           $('.predictive-search--view-all').hide();
                         }
                       // console.log($(data).find('.search-results--root').html());
                    }
                });
               
                
              } else {
                  $('.result').html('');
                 console.log('ITG0004');
                  $('.predictive-search--view-all').hide();
                           $(document).find('body').removeClass("SearchLoaderHeader");
                
              }

        
   
     console.log($(this).val().trim())
      if(!$(this).val().trim()){
       $('.result').html('');
        console.log('emotasfjl',$('.result .search-results--products').html(),"red");
      }
                           $(document).find('body').removeClass("SearchLoaderHeader");
     
       }, 1250);
   });

    $('.cstm_search__input').on('change', function() {
      var inputVal = $(this).val();
      if (inputVal === " ") {
         $('.result .search-results--products').html(" ");
      }
    });
  
      $('.search--cancel').on('click', function() {
       $('.cstm_search__input').val('');
         $('.result').html('');
         $('.predictive-search--view-all').hide();
      });


 
});



// $(document).on('DOMSubtreeModified', '.header--right-side-split-menu span.cart--external--total-items', function() {
//   console.log('changed');
//   console.log($(this).text());
//   $(document).find('.cartDrawerRoot span.cart_count.cart--external--total-items').text();
  
// });



$(document).ready(function() {
    // Select the target node
    var targetNode = document.querySelector('.header--right-side-split-menu span.cart--external--total-items');

    // Options for the observer
    var config = { childList: true, characterData: true, subtree: true };

    // Callback function to execute when mutations are observed
    var callback = function(mutationsList, observer) {
        for (var mutation of mutationsList) {
            if (mutation.type === 'childList' || mutation.type === 'characterData') {
                // Log the updated text content
                console.log('Updated text content:', targetNode.textContent.trim());
                $(document).find('.cartDrawerRoot span.cart_count.cart--external--total-items').text( '('+targetNode.textContent.trim()+ ')' );
            }
        }
    };

    // Create an instance of MutationObserver and pass in the callback
    var observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);

    // To stop observing when no longer needed
    // observer.disconnect();
});
